import { ISolutionPage } from '..'
import React from 'react'
import { Statistics } from 'marketing-site/src/library/components/Statistics'
import { CardsWithIcon } from 'marketing-site/src/library/components/CardsWithIcon'
import { SpotlightList } from 'marketing-site/src/library/components/SpotlightList'
import { CTATheme, Icon } from 'marketing-site/src/library/utils'

export function OverviewTab(page: ISolutionPage): React.ReactElement {
  return !!page.solution ? (
    <>
      <Statistics
        heading=""
        statistics={page.solution.statistics.map((statistic) => ({
          stat: statistic.line1,
          description: statistic.line2,
        }))}
      />

      <CardsWithIcon
        header={'How Intercom Can Benefit Your Support Teams'}
        cards={page.solution.benefits.map((benefit) => ({
          body: benefit.description,
          icon: benefit.icon,
        }))}
      />

      <SpotlightList
        heading={'Key resources to help you make a decision'}
        listItems={page.solution.resources.map((resource) => ({
          title: resource.title,
          description: resource.description,
          cta: { bgColor: CTATheme.LinkOnlyBlack, icon: Icon.Arrow, text: 'Learn more', url: '#' },
          image: resource.image,
          eyebrow: resource.type,
        }))}
      />
    </>
  ) : (
    <>{`Nothing to see here`}</>
  )
}
